













import { Vue, Component, Prop } from "vue-property-decorator";
import { VIPCapabilityCertificate, VIPCertificate } from "@/loader";
import { Dayjs } from "dayjs";

@Component
export default class CertificateListItem extends Vue {
	@Prop({ type: VIPCertificate, default: null })
	public item!: VIPCertificate | VIPCapabilityCertificate | null;

	@Prop({ type: Dayjs, default: null })
	public date!: Dayjs | null;

	public get localItem(): VIPCertificate | null {
		if (!this.item) {
			return null;
		}
		if (this.item instanceof VIPCapabilityCertificate) {
			return this.item.certificate;
		}
		return this.item;
	}
}
